import React, { useEffect, useState } from 'react'
import Paper from '@modul-connect/shared/components/atoms/paper'
import Page from '@modul-connect/shared/components/atoms/page.v2'
import { connect, useDispatch, useSelector } from 'react-redux'
import SearchWidget from '@modul-connect/shared/components/molecules/searchWidget.v2'
import TableWidget from '@modul-connect/shared/components/molecules/tableWidget'
import { allVehicles_columns } from '../team_columns'
import KpiRow from '@modul-connect/shared/components/molecules/kpiRow/kpiRow'
import { getAllVehiclesFromOrganisation } from '../../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'


export const FleetVehicles = ({ orgId }) => {

  const [vehicles, setVehicles] = useState('')
  const [tableOptions, setTableOptions] = useState(null)
  const [kpiData, setKpiData] = useState([])

  const loading = useSelector(state => state.loading)
  const allVehicles = useSelector(state => state.all_vehicles)
  
  const isLoading = loading.allVehicles === 'loading'
  
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth0()

  useEffect(() =>  {
    getAccessTokenSilently().then(token => {
      dispatch(getAllVehiclesFromOrganisation(token, orgId))
    })
  }, [orgId])
  
  const formattedData = allVehicles?.vehicles?.map((vehicle) => ({
    vehicleName: vehicle.vehicleName?.length ? vehicle.vehicleName : vehicle.baseVehicleName,
    model: `${vehicle.model} ${vehicle.brandName}`,
    year: vehicle.year,
    licenseNumber: vehicle.licenseNumber,
    date: vehicle.added.split('T')[0],
    team: vehicle.teams.join(', ')
    
  }))
  
  let filterTimer = null

  useEffect(() => {  
    const vehiclesInTeam = allVehicles.vehicles.filter(v => v.teams.length > 0).length
    
    setKpiData([
      { title: 'Total Vehicles', value: allVehicles.total },
      { title: 'In teams', value: vehiclesInTeam },
    ])
  }, [orgId, allVehicles])

  const handleNameChange = (event) => {
    setFilterAfterDelay(event.target.value)
  }

  const setFilterAfterDelay = (newFilter) => {
    if (filterTimer) {
      clearTimeout(filterTimer)
    }

    filterTimer = setTimeout(() => {
      setVehicles(newFilter)
    }, 1000)
  }

  const sortByColumn = (data, column) => {
    if (!Array.isArray(data)) return data
      
    const isDesc = column.endsWith('desc')
    const key = isDesc ? column.replace(/desc$/i, '') : column
  
    return [...data].sort((a, b) => {
      const v1 = a[key] || ''
      const v2 = b[key] || ''
      return isDesc
        ? v2.localeCompare(v1, undefined, { numeric: true })
        : v1.localeCompare(v2, undefined, { numeric: true })
    })
  }

  const filteredData = formattedData?.filter((vehicle) =>
    vehicle.vehicleName.toLowerCase().includes(vehicles.toLowerCase()) ||
    vehicle.model.toLowerCase().includes(vehicles.toLowerCase()) ||
    vehicle.team.toLowerCase().includes(vehicles.toLowerCase()) ||
    vehicle.year?.toLowerCase().includes(vehicles.toLowerCase())

  )

  const sortKey = tableOptions?.sort || 'name'
  const sortedUsers = sortByColumn(filteredData, sortKey)

  const usersToDisplay = !tableOptions ? sortedUsers : sortedUsers?.
    slice(tableOptions.rowsPerPage * (tableOptions.currentpage -1), filteredData.length)


  return (
    <Page>
      <KpiRow width={'100%'} bgColor={'white'} data={kpiData} isLoading={isLoading} /> 
      <Paper title={'Vehicles'}>
        <SearchWidget
          onChange={handleNameChange}
          placeholder={'Search for vehicle...'}
          initialValue={vehicles}
        />
        <TableWidget
          data={usersToDisplay}
          columns={allVehicles_columns}
          totalItems={filteredData?.length}
          defaultSort="name"
          searchStr={vehicles}
          themes={{ device: 'desktop' }} 
          disableClickCondition={() => true}
          loadingStatus={loading?.allVehicles}
          extend={{ width: '100%', paddingTop: 24 }}
          onFetchData={(options) => {
            setTableOptions((options))
          }}
        />
      </Paper>
    </Page>
  )
  
}


const mapStateToProps = props => props

const mapDispatchToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(FleetVehicles)